module.exports = __webpack_public_path__ + "img/jante_pneus_.222bf714.png";